import axios from "axios";
import authHeader from "@/services/auth-header";
import ConstApiUrls from "@/services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL;

class FtRegistrationService {
  getApiUrl() {
    return API_URL;
  }
  getAllFtRegistration() {
    return axios.get(API_URL + `getAllFtRegistration`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationPublic() {
    return axios.get(API_URL + `public/getAllFtRegistration`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationContaining(page, pageSize, sortBy, order, search) {
    return axios.get(
      API_URL +
        `getAllFtRegistrationContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
      { headers: authHeader() }
    );
  }
  getAllFtRegistrationByFmeetingBeanContaining(page, pageSize, sortBy, order, search, fmeetingBean) {
    return axios.get(
        API_URL +
        `getAllFtRegistrationByFmeetingBeanContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}&fmeetingBean=${fmeetingBean}`,
        { headers: authHeader() }
    );
  }

  getFtRegistrationById(id) {
    return axios.get(API_URL + `getFtRegistrationById/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationByUserBean(userBean) {
    return axios.get(API_URL + `getAllFtRegistrationByUserBean/${userBean}`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationByParent(fmeetingBean) {
    return axios.get(API_URL + `getAllFtRegistrationByParent/${fmeetingBean}`, {
      headers: authHeader(),
    });
  }
  getPostAllFtRegistrationByMeeting(listIds) {
    return axios.post(API_URL + `getPostAllFtRegistrationByMeeting`, listIds, {
      headers: authHeader(),
    });
  }
  getPostAllFtRegistrationByMeetingExt(items) {
    return axios.post(API_URL + `getPostAllFtRegistrationByMeetingExt`, items, {
      headers: authHeader(),
    });
  }

  updateFtRegistration(item) {
    return axios.put(API_URL + `updateFtRegistration/${item.id}`, item, {
      headers: authHeader(),
    });
  }
  createFtRegistration(item) {
    return axios.post(API_URL + `createFtRegistration`, item, {
      headers: authHeader(),
    });
  }

  deleteFtRegistration(id) {
    return axios.delete(API_URL + `deleteFtRegistration/${id}`, {
      headers: authHeader(),
    });
  }
  deleteAllFtRegistration(itemIds) {
    return axios.delete(API_URL + `deleteAllFtRegistration`, {
      headers: authHeader(),
      data: itemIds,
    });
  }

  enroll(item) {
    return axios.post(API_URL + `enroll`, item, {
      headers: authHeader(),
    });
  }
  checkEnrolledPublic(fmeetingBean, userBean) {
    return axios.get(API_URL + `public/checkEnrolled?fmeetingBean=${fmeetingBean}&userBean=${userBean}`, {
      headers: authHeader(),
    });
  }


}
export default new FtRegistrationService();
